import React from "react";
import { useForm } from "react-hook-form";
import Autocomplete from "react-google-autocomplete";

// images (update paths if needed)
import planetakeoff from "../../../../assets/images/plane-takeoff.svg";
import mappinhouse from "../../../../assets/images/map-pin-house.svg";
import { useSelector } from "react-redux";

export default function FlightSlugBanner() {
  const place = useSelector((state) => state.place);
  const localSelectedCity = localStorage.getItem('selectedCity');
  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log("Flight Search Payload 👉", data);

    // 👉 API call / navigation logic here
    // navigate(`/flight/${data.destination}`)
  };
  return (
    <div className="flightSlugbanContainer">
      <h1>Flight Search</h1>
      <div className="flight-booking-form">

        <div className="tab-content" id="pills-tabContent">
          <div className="tab-pane fade show active" id="pills-home" role="tabpanel"
            aria-labelledby="pills-home-tab" tabIndex="0">
            <form className="booking-search-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="row gy-3">
                <div className="col-md-6">
                  <div className="search-item">
                    <label className="form-label">Departure city?</label>
                    <div
                      className="search-control-wrapper input-group custom-input d-flex align-items-center bg-white">
                      <span><img src={planetakeoff} alt="" /></span>
                      <Autocomplete
                        className="ps-2 form-control border-0 outline-0 shadow-none p-0 bg-transparent"
                        apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                        placeholder="Enter Departure City"
                        onPlaceSelected={(city) => {
                          if (!city || !city.formatted_address) return;

                          const selectedCity = city.formatted_address.split(",")[0];

                          setValue("departureCity", selectedCity, {
                            shouldValidate: true,
                          });
                          trigger("departureCity");
                        }}
                      />
                      <input
                        type="hidden"
                        {...register("departureCity", { required: "Destination is required" })}
                      />
                    </div>
                    {errors.departureCity && (
                      <p className="text-danger small">{errors.departureCity.message}</p>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="search-item">
                    <label className="form-label">Destination</label>
                    <div
                      className="search-control-wrapper input-group custom-input d-flex align-items-center bg-white">
                      <span><img src={mappinhouse} alt="" /></span>
                      <Autocomplete
                        className="ps-2 form-control border-0 outline-0 shadow-none p-0 bg-transparent"
                        apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                        placeholder={
                          localSelectedCity && localSelectedCity !== "undefined" && place
                            ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                            : "Where would you like to go"
                        }

                        onPlaceSelected={async (city) => {
                          const selectedCity = city.formatted_address.split(",")[0].toLowerCase();
                          // Update route
                          if (!city) return;
                          const cityName = city.formatted_address.split(",")[0];
                          setValue("destination", cityName, { shouldValidate: true });
                          trigger("destination");

                          // // Dispatch Redux actions
                          // dispatch(setPlace(selectedCity));
                          // localStorage.setItem('selectedCity', city.formatted_address.split(',')[0]);
                        }}
                      />
                      <input
                        type="hidden"
                        {...register("destination", { required: "Destination is required" })}
                      />
                    </div>
                    {errors.destination && (
                      <p className="text-danger small">{errors.destination.message}</p>
                    )}
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="search-item">
                    <label className="form-label">Check-In</label>
                    <div
                      className="search-control-wrapper input-group custom-input d-flex align-items-center gap-3 bg-white">
                      <input
                        type="date"
                        className="form-control border-0 outline-0 shadow-none p-0 bg-transparent"
                        {...register("checkInDate", { required: "Check-In-Date is required" })}
                      />
                      {errors.checkInDate && (
                        <p className="text-danger small">{errors.checkInDate.message}</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="search-item">
                    <label className="form-label">Check-Out</label>
                    <div
                      className="search-control-wrapper input-group custom-input d-flex align-items-center gap-3 bg-white">
                      <input
                        type="date"
                        className="form-control border-0 outline-0 shadow-none p-0 bg-transparent"
                        {...register("dropOffDate", { required: "Drop-Off-Date is required" })}
                      />
                      {errors.dropOffDate && (
                        <p className="text-danger small">{errors.dropOffDate.message}</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="search-item">
                    <label className="form-label">Passenger</label>
                    <div
                      className="search-control-wrapper input-group custom-input d-flex align-items-center bg-white">
                      <input
                        type="number"
                        placeholder='Enter No. of Passenger'
                        className="form-control border-0 outline-0 shadow-none p-0 bg-transparent"
                        {...register("passenger", {
                          required: "Please enter number of passenger",
                          min: { value: 1, message: "Minimum 1 person required" },
                          validate: (value) =>
                            Number.isInteger(Number(value)) ||
                            "Must be a valid number",
                        })}
                      />
                      {errors.passenger && (
                        <p className="text-danger small">{errors.passenger.message}</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 align-content-end">
                  <div className="search-item">
                    <button
                      className="view-all-btn w-100 justify-content-center gap-2 align-items-center">
                      <i className="fa-solid fa-magnifying-glass"></i> Search
                    </button>
                  </div>
                </div>

              </div>

            </form>
          </div>
          <div className="tab-pane fade" id="pills-profile" role="tabpanel"
            aria-labelledby="pills-profile-tab" tabIndex="0">

          </div>

        </div>
      </div>

    </div>
  )
}
